import { TopoNode } from "../Topology/TopoNode";
import { TopoMap } from "../Topology/TopoMap";
import { List } from "../Utils/List";
import { Point, Matrix } from "../Utils/Matrix";

export class GridLayout {
	private static DefaultNodeMargin = 70;
	private static MinNodesPerRow = 25;
	private _topoMap: TopoMap;

	public NodeMargin: number;
		
	constructor(topoMap: TopoMap) {
		this._topoMap = topoMap;
		this.NodeMargin = GridLayout.DefaultNodeMargin;
	}

	public LayoutNodes(nodes: List<TopoNode>): void {
		// Place all the nodes at zero and finde
		// the largest node
		var nodeSize = 0;
		nodes.ForEach((node) => {
			if (node.Height > nodeSize)
				nodeSize = node.Height;
			if (node.Width > nodeSize)
				nodeSize = node.Width;

			node.Location = new Point(0, 0);
		});
			
		// Calculate map size so Map Left and Top are correct
		// calculate after setting grid nodes to zero.
		this._topoMap.CalculateSize();

		// Calculate number of nodes per row
		var nodesPerRow = GridLayout.MinNodesPerRow;
		if (this._topoMap.Width / (nodeSize + this.NodeMargin) > GridLayout.MinNodesPerRow)
			nodesPerRow = this._topoMap.Width / (nodeSize + this.NodeMargin);
		var rows = Math.ceil(nodes.Count / nodesPerRow);
			
		// Determine the point to begin drawing
		var drawPosition = new Point(this._topoMap.Left, this._topoMap.Top - (rows * (nodeSize + this.NodeMargin)));

		var nodesOnRow = 0;
		nodes.ForEach((node) => {
			node.Location = drawPosition;
			nodesOnRow++;

			// Move draw position to the right
			drawPosition.X += nodeSize + this.NodeMargin;

			// Row full reset to next row
			if (nodesOnRow >= nodesPerRow) {
				drawPosition.X = this._topoMap.Left;
				drawPosition.Y += nodeSize + this.NodeMargin;
				nodesOnRow = 0;
			}
		});
	}
}
